<template>
  <div class="ev-config-page">
    <div class="page-header">
      <div class="header-left">
        <el-button size="mini" icon="el-icon-back" @click="goBack">返回推导</el-button>
        <span class="page-title">EV 算法配置</span>
        <el-radio-group :value="activePath" size="mini" @input="openItem">
          <el-radio-button v-for="item in items" :key="item.path" :label="item.path">{{ item.label }}</el-radio-button>
        </el-radio-group>
      </div>
    </div>
    <div class="page-body">
      <router-view />
    </div>
  </div>
</template>

<script>
const ITEMS = [
  { path: "/work_common/ev_simulate/config/template", label: "区域初始车辆" },
  { path: "/work_common/ev_simulate/config/solver", label: "算法参数" },
  { path: "/work_common/ev_simulate/config/inventory", label: "库存需求" }
];

export default {
  data() {
    return {
      items: ITEMS
    };
  },

  computed: {
    activePath() {
      const path = this.$route.path;
      const hit = ITEMS.find((item) => path === item.path || path.startsWith(item.path + "/"));
      return hit ? hit.path : ITEMS[0].path;
    }
  },

  methods: {
    openItem(path) {
      if (path && path !== this.$route.path) {
        this.$router.push(path);
      }
    },

    goBack() {
      this.$router.push("/work_common/ev_simulate");
    }
  }
};
</script>

<style lang="less" scoped>
.ev-config-page {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 100px);
  padding: 6px 12px 8px;
  box-sizing: border-box;
  overflow: hidden;
}

.page-header {
  flex-shrink: 0;
  margin-bottom: 8px;
  padding-bottom: 8px;
  border-bottom: 1px solid #ebeef5;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.page-title {
  font-size: 15px;
  font-weight: 600;
  color: #303133;
}

.page-body {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: auto;
}
</style>
